var _sodipodiNamedview, _linearGradient;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThorChartsLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 2550 650",
    id: "svg9",
    sodipodiDocname: "ThorCharts_Logo&Text_White.svg",
    inkscapeVersion: "1.2.1 (9c6d41e410, 2022-07-14)",
    "inkscapeExport-filename": "Test2.svg",
    "inkscapeExport-xdpi": 300,
    "inkscapeExport-ydpi": 300,
    width: 2550,
    height: 650,
    xmlSpace: "preserve",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs13"
  }, /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    id: "mask21497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g21515",
    transform: "matrix(1.0759259,0,0,1.0759259,-174.60879,-69.935186)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 22.5,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect21499",
    width: 628.95868,
    height: 462.80991,
    x: -16.198347,
    y: -20.826447
  }), /*#__PURE__*/React.createElement("g", {
    id: "g21513",
    style: {
      stroke: "#000000",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal",
      fill: "none",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 22.5,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 334.95817,289.07455 -71.99633,-73.6326",
    id: "path21501",
    sodipodiNodetypes: "cc",
    inkscapeLabel: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal",
      fill: "none",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 22.5,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 269.94857,348.51878 -71.99633,-73.6326",
    id: "path21503",
    sodipodiNodetypes: "cc",
    inkscapeLabel: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal",
      fill: "none",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 22.5,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 305.58494,322.13861 -71.99633,-73.6326",
    id: "path21505",
    sodipodiNodetypes: "cc",
    inkscapeLabel: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal",
      fill: "none",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 22.5,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 346.37833,137.54357 274.382,63.910979",
    id: "path21507",
    sodipodiNodetypes: "cc",
    inkscapeLabel: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal",
      fill: "none",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 22.5,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 375.15519,103.60969 303.15886,29.977088",
    id: "path21509",
    sodipodiNodetypes: "cc",
    inkscapeLabel: "Rectangle",
    mask: "none"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal",
      fill: "none",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 22.5,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 317.68412,171.7915 245.68779,98.15891",
    id: "path21511",
    sodipodiNodetypes: "cc",
    inkscapeLabel: "Rectangle"
  }))))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview11",
    pagecolor: "#101921",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1",
    showgrid: "false",
    inkscapeCoom: 0.5,
    inkscapeCx: 1229,
    inkscapeCy: 740,
    "inkscapeWindow-width": 2560,
    "inkscapeWindow-height": 1377,
    "inkscapeWindow-x": -8,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "svg9",
    showguides: "false"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 0.004404,
    x2: 253.2644,
    y1: 145.25301,
    y2: 145.25301
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0cf",
    id: "stop2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f9",
    id: "stop4"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 0,290.5 202.8,205.1 138.6,140 Z M 74.5,75 138.7,140 253.3,0 Z",
    fill: "url(#a)",
    fillRule: "nonzero",
    transform: "matrix(1.8372736,0,0,1.8372736,57.139103,57.61135)",
    id: "path7",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1
    },
    inkscapeLabel: "Logo",
    mask: "url(#mask21497)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "path1703",
    inkscapeLabel: "Line Long",
    transform: "matrix(1.0455782,0,0,1.0455782,31.092547,32.923282)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#33ff99",
      strokeMiterlimit: 2,
      InkscapeStroke: "none"
    },
    d: "M 483.41602,4.1875 266.48633,266.60352 1.4355469,553.52344 6.9902344,558.6543 272.11133,271.6582 a 3.7815781,3.7815781 0 0 0 0.13672,-0.15625 L 489.24609,9.0058594 Z",
    id: "path2281"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2265"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#33ff99",
      strokeLinecap: "round",
      strokeMiterlimit: 2,
      InkscapeStroke: "none"
    },
    d: "m 487.17773,1.375 -31.93945,3.03125 a 3.7811999,3.7811999 0 0 0 -3.4082,4.1210938 3.7811999,3.7811999 0 0 0 4.12109,3.4062502 L 484.12891,9.2617188 486.80273,37.4375 a 3.7811999,3.7811999 0 0 0 4.1211,3.40625 3.7811999,3.7811999 0 0 0 3.40625,-4.121094 L 491.30078,4.78125 A 3.7815781,3.7815781 0 0 0 487.17773,1.375 Z",
    id: "path2275"
  }), /*#__PURE__*/React.createElement("g", {
    id: "path2267"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#33ff99",
      fillRule: "evenodd",
      strokeWidth: "0.667271pt",
      strokeMiterlimit: 2,
      InkscapeStroke: "none"
    },
    d: "m 6.4764879,553.63855 c 1.3527886,1.24968 1.4364712,3.36182 0.1867914,4.71461 -1.2496798,1.35279 -3.3618281,1.43647 -4.7146166,0.18679 -1.35278864,-1.24968 -1.4093042,-3.39123 -0.1867914,-4.71461 1.2496798,-1.35279 3.3618281,-1.43647 4.7146166,-0.18679 z",
    id: "path2271"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#33ff99",
      fillRule: "evenodd",
      strokeMiterlimit: 2,
      InkscapeStroke: "none"
    },
    d: "m 4.0625,552.31445 c -0.9679836,0.0384 -1.9204526,0.44419 -2.6269531,1.20899 -1.38946298,1.5041 -1.32338276,3.92637 0.2109375,5.34375 1.5295848,1.413 3.9307489,1.31669 5.34375,-0.21289 1.4130001,-1.52959 1.3186469,-3.9288 -0.2109375,-5.3418 C 6.0145045,552.606 5.0304836,552.2761 4.0625,552.31445 Z m 0.035156,0.88282 c 0.738706,-0.0293 1.4881772,0.2244 2.0761719,0.76757 1.1759901,1.08636 1.2484664,2.90995 0.1621094,4.08594 -1.086356,1.17599 -2.909948,1.24847 -4.0859375,0.16211 -1.1712543,-1.08198 -1.2176696,-2.94328 -0.1621094,-4.08594 0.543178,-0.58799 1.2710597,-0.90042 2.0097656,-0.92968 z",
    id: "path2273"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "path5114",
    inkscapeLabel: "Line Short",
    transform: "matrix(1.0455782,0,0,1.0455782,31.092547,32.923282)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#33ff99",
      strokeMiterlimit: 2,
      InkscapeStroke: "none"
    },
    d: "m 134.09375,127.62109 -5.4082,5.28711 136.11718,139.20899 a 3.7815781,3.7815781 0 0 0 0.0274,0.0273 l 136.11523,136.42578 5.35352,-5.34179 -136.10156,-136.41211 z",
    id: "path2261"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2245"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#33ff99",
      strokeLinecap: "round",
      strokeMiterlimit: 2,
      InkscapeStroke: "none"
    },
    d: "m 130.11133,125.13086 a 3.7815781,3.7815781 0 0 0 -3.82422,3.73828 l -0.36133,32.08398 a 3.7811999,3.7811999 0 0 0 3.74024,3.82227 3.7811999,3.7811999 0 0 0 3.82226,-3.73828 l 0.31836,-28.30078 28.30078,0.31836 a 3.7811999,3.7811999 0 0 0 3.82422,-3.73828 3.7811999,3.7811999 0 0 0 -3.73828,-3.82422 z",
    id: "path2255"
  }), /*#__PURE__*/React.createElement("g", {
    id: "path2247"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#33ff99",
      fillRule: "evenodd",
      strokeWidth: "0.667271pt",
      strokeMiterlimit: 2,
      InkscapeStroke: "none"
    },
    d: "m 401.26586,403.53799 c 1.30373,-1.30078 3.41754,-1.29838 4.71831,0.005 1.30078,1.30373 1.29838,3.41754 -0.005,4.71831 -1.30373,1.30078 -3.44582,1.27004 -4.71831,-0.005 -1.30078,-1.30373 -1.29838,-3.41754 0.005,-4.71831 z",
    id: "path2251"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#33ff99",
      fillRule: "evenodd",
      strokeMiterlimit: 2,
      InkscapeStroke: "none"
    },
    d: "m 403.62695,402.12109 c -0.96873,-10e-4 -1.93872,0.36618 -2.67578,1.10157 -1.47374,1.47079 -1.47664,3.87354 -0.006,5.34765 1.44629,1.44919 3.86898,1.4812 5.34766,0.006 1.47374,-1.47079 1.47664,-3.87354 0.006,-5.34765 -0.7354,-0.73688 -1.70315,-1.10638 -2.67188,-1.10743 z m -0.002,0.88477 c 0.7393,8e-4 1.47955,0.28506 2.04492,0.85156 1.13078,1.13334 1.12716,2.9591 -0.006,4.08985 -1.12878,1.12622 -2.9892,1.09502 -4.08789,-0.006 -1.13078,-1.13335 -1.12911,-2.95715 0.004,-4.08789 0.56667,-0.56539 1.30562,-0.84846 2.04492,-0.84766 z",
    id: "path2253"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m 764.07198,238.22399 v 171.12 h -31 v -171.12 z m 53.072,0 v 25.296 h -137.144 v -25.296 z",
    style: {
      fontWeight: 600,
      fontSize: 248,
      fontFamily: "'Exo 2'",
      InkscapeFontSpecification: "'Exo 2 Semi-Bold'",
      letterSpacing: "32.5px",
      mixBlendMode: "multiply",
      fillRule: "nonzero",
      strokeWidth: 7.562,
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "path1136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 904.70008,238.22399 v 171.12 h -31 v -171.12 z m 71.424,67.704 v 24.304 h -73.408 v -24.304 z m 28.27202,-67.704 v 171.12 h -31.00002 v -171.12 z",
    style: {
      fontWeight: 600,
      fontSize: 248,
      fontFamily: "'Exo 2'",
      InkscapeFontSpecification: "'Exo 2 Semi-Bold'",
      letterSpacing: "32.5px",
      mixBlendMode: "multiply",
      fillRule: "nonzero",
      strokeWidth: 7.562,
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "path1139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1140.064,234.99999 q 19.84,0 33.48,4.464 13.64,4.216 21.824,14.384 8.432,10.168 12.152,27.28 3.72,17.112 3.72,42.656 0,25.296 -3.72,42.656 -3.72,17.112 -12.152,27.28 -8.184,10.168 -21.824,14.632 -13.64,4.216 -33.48,4.216 -19.344,0 -32.984,-4.216 -13.64,-4.464 -22.072,-14.632 -8.432,-10.168 -12.152,-27.28 -3.72,-17.36 -3.72,-42.656 0,-25.544 3.72,-42.656 3.72,-17.112 12.152,-27.28 8.432,-10.168 22.072,-14.384 13.64,-4.464 32.984,-4.464 z m 0,25.296 q -14.632,0 -23.064,5.952 -8.184,5.704 -11.656,19.592 -3.472,13.64 -3.472,37.944 0,24.304 3.472,38.192 3.472,13.64 11.656,19.592 8.432,5.704 23.064,5.704 14.88,0 23.064,-5.704 8.432,-5.952 11.904,-19.592 3.472,-13.888 3.472,-38.192 0,-24.304 -3.472,-37.944 -3.472,-13.888 -11.904,-19.592 -8.184,-5.952 -23.064,-5.952 z",
    style: {
      fontWeight: 600,
      fontSize: 248,
      fontFamily: "'Exo 2'",
      InkscapeFontSpecification: "'Exo 2 Semi-Bold'",
      letterSpacing: "32.5px",
      mixBlendMode: "multiply",
      fillRule: "nonzero",
      strokeWidth: 7.562,
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "path1142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1338.9722,235.99199 q 21.328,0 34.472,4.464 13.392,4.464 19.344,15.376 6.2,10.664 6.2,30.256 0,12.896 -3.224,22.072 -2.976,8.928 -10.168,14.384 -6.944,5.208 -18.848,6.696 v 1.24 q 4.216,0.992 8.68,3.968 4.712,2.728 8.432,7.936 3.968,5.208 5.952,13.392 l 15.624,53.568 h -32.736 l -14.136,-52.824 q -2.728,-8.928 -7.44,-12.4 -4.712,-3.72 -12.896,-3.72 -16.12,0 -27.528,0 -11.408,-0.248 -19.096,-0.496 -7.44,-0.248 -13.144,-0.248 l 0.744,-23.56 h 59.024 q 11.16,-0.248 17.608,-2.48 6.448,-2.48 9.176,-8.432 2.728,-6.2 2.728,-17.36 0,-10.912 -2.728,-16.864 -2.728,-5.952 -9.176,-8.184 -6.448,-2.48 -17.608,-2.48 -21.824,0 -37.448,0.248 -15.624,0.248 -21.328,0.496 l -3.472,-22.816 q 9.92,-0.992 18.6,-1.488 8.928,-0.496 19.344,-0.496 10.416,-0.248 25.048,-0.248 z m -32.488,2.232 v 171.12 h -30.504 v -171.12 z",
    style: {
      fontWeight: 600,
      fontSize: 248,
      fontFamily: "'Exo 2'",
      InkscapeFontSpecification: "'Exo 2 Semi-Bold'",
      letterSpacing: "32.5px",
      mixBlendMode: "multiply",
      fillRule: "nonzero",
      strokeWidth: 7.562,
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "path1145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1529.9444,235.24799 q 11.656,0 19.84,0.744 8.184,0.496 15.128,1.736 6.944,0.992 14.384,2.976 l -2.728,23.064 q -7.688,-0.496 -14.384,-0.744 -6.696,-0.496 -14.384,-0.744 -7.44,-0.248 -17.856,-0.248 -14.384,0 -22.568,5.704 -8.184,5.704 -11.656,19.096 -3.224,13.392 -3.224,36.952 0,23.56 3.224,36.952 3.472,13.392 11.656,19.096 8.184,5.704 22.568,5.704 16.616,0 27.776,-0.496 11.408,-0.744 22.32,-1.984 l 2.728,22.816 q -11.16,3.472 -23.064,4.96 -11.904,1.488 -29.76,1.488 -25.792,0 -41.168,-8.432 -15.376,-8.68 -22.32,-28.024 -6.696,-19.344 -6.696,-52.08 0,-32.736 6.696,-52.08 6.944,-19.344 22.32,-27.776 15.376,-8.68 41.168,-8.68 z",
    style: {
      fontWeight: 600,
      fontSize: 248,
      fontFamily: "'Exo 2'",
      InkscapeFontSpecification: "'Exo 2 Semi-Bold'",
      letterSpacing: "32.5px",
      mixBlendMode: "multiply",
      fillRule: "nonzero",
      strokeWidth: 7.562,
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "path1148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1673.0524,238.22399 v 171.12 h -31 v -171.12 z m 71.424,67.704 v 24.304 h -73.408 v -24.304 z m 28.272,-67.704 v 171.12 h -31 v -171.12 z",
    style: {
      fontWeight: 600,
      fontSize: 248,
      fontFamily: "'Exo 2'",
      InkscapeFontSpecification: "'Exo 2 Semi-Bold'",
      letterSpacing: "32.5px",
      mixBlendMode: "multiply",
      fillRule: "nonzero",
      strokeWidth: 7.562,
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "path1151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1918.8323,238.22399 q 3.968,0 6.944,2.232 2.976,2.232 4.216,5.952 l 51.832,162.936 h -31.744 l -39.184,-131.936 q -0.992,-3.968 -1.984,-7.936 -0.992,-3.968 -1.736,-7.688 h -6.944 q -0.744,3.72 -1.736,7.688 -0.992,3.968 -2.232,7.936 l -38.936,131.936 h -31.744 l 51.832,-162.936 q 0.992,-3.72 3.968,-5.952 3.224,-2.232 7.192,-2.232 z m 28.768,97.96 v 24.304 h -88.04 v -24.304 z",
    style: {
      fontWeight: 600,
      fontSize: 248,
      fontFamily: "'Exo 2'",
      InkscapeFontSpecification: "'Exo 2 Semi-Bold'",
      letterSpacing: "32.5px",
      mixBlendMode: "multiply",
      fillRule: "nonzero",
      strokeWidth: 7.562,
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "path1154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2097.6521,235.99199 q 21.328,0 34.472,4.464 13.392,4.464 19.344,15.376 6.2,10.664 6.2,30.256 0,12.896 -3.224,22.072 -2.976,8.928 -10.168,14.384 -6.944,5.208 -18.848,6.696 v 1.24 q 4.216,0.992 8.68,3.968 4.712,2.728 8.432,7.936 3.968,5.208 5.952,13.392 l 15.624,53.568 h -32.736 l -14.136,-52.824 q -2.728,-8.928 -7.44,-12.4 -4.712,-3.72 -12.896,-3.72 -16.12,0 -27.528,0 -11.408,-0.248 -19.096,-0.496 -7.44,-0.248 -13.144,-0.248 l 0.744,-23.56 h 59.024 q 11.16,-0.248 17.608,-2.48 6.448,-2.48 9.176,-8.432 2.728,-6.2 2.728,-17.36 0,-10.912 -2.728,-16.864 -2.728,-5.952 -9.176,-8.184 -6.448,-2.48 -17.608,-2.48 -21.824,0 -37.448,0.248 -15.624,0.248 -21.328,0.496 l -3.472,-22.816 q 9.92,-0.992 18.6,-1.488 8.928,-0.496 19.344,-0.496 10.416,-0.248 25.048,-0.248 z m -32.488,2.232 v 171.12 h -30.504 v -171.12 z",
    style: {
      fontWeight: 600,
      fontSize: 248,
      fontFamily: "'Exo 2'",
      InkscapeFontSpecification: "'Exo 2 Semi-Bold'",
      letterSpacing: "32.5px",
      mixBlendMode: "multiply",
      fillRule: "nonzero",
      strokeWidth: 7.562,
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "path1157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2292.3441,238.22399 v 171.12 h -31 v -171.12 z m 53.072,0 v 25.296 h -137.144 v -25.296 z",
    style: {
      fontWeight: 600,
      fontSize: 248,
      fontFamily: "'Exo 2'",
      InkscapeFontSpecification: "'Exo 2 Semi-Bold'",
      letterSpacing: "32.5px",
      mixBlendMode: "multiply",
      fillRule: "nonzero",
      strokeWidth: 7.562,
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "path1160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2454.5482,234.99999 q 12.648,0.248 26.536,1.488 14.136,1.24 27.528,4.712 l -1.984,21.08 q -10.664,-0.248 -24.8,-0.496 -13.888,-0.496 -26.784,-0.496 -7.936,0 -13.64,0.496 -5.456,0.496 -8.928,2.48 -3.472,1.984 -5.208,6.2 -1.488,3.968 -1.488,11.16 0,11.16 4.464,15.872 4.712,4.712 15.128,7.44 l 33.728,9.92 q 20.336,6.2 28.024,18.104 7.688,11.656 7.688,31.248 0,14.632 -3.472,24.056 -3.472,9.424 -10.664,14.632 -7.192,5.208 -18.848,7.44 -11.656,2.232 -28.024,2.232 -8.432,0 -23.312,-0.992 -14.632,-0.992 -33.48,-4.96 l 1.984,-22.32 q 14.632,0.496 24.552,0.992 9.92,0.248 17.112,0.248 7.192,0 13.392,0 11.408,0 17.856,-1.488 6.448,-1.488 8.928,-6.2 2.728,-4.712 2.728,-13.64 0,-7.688 -1.984,-11.904 -1.736,-4.464 -5.952,-6.944 -4.216,-2.48 -10.912,-4.216 l -34.968,-10.664 q -19.344,-5.952 -27.28,-17.608 -7.688,-11.656 -7.688,-31.248 0,-14.632 3.472,-23.808 3.472,-9.424 10.664,-14.136 7.192,-4.96 18.352,-6.696 11.408,-1.984 27.28,-1.984 z",
    style: {
      fontWeight: 600,
      fontSize: 248,
      fontFamily: "'Exo 2'",
      InkscapeFontSpecification: "'Exo 2 Semi-Bold'",
      letterSpacing: "32.5px",
      mixBlendMode: "multiply",
      fillRule: "nonzero",
      strokeWidth: 7.562,
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "path1163"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThorChartsLogoWhite);
export default __webpack_public_path__ + "static/media/ThorChartsLogoWhite.2e35565f045859f691a0622e302268f5.svg";
export { ForwardRef as ReactComponent };